import { render, staticRenderFns } from "./survey-funding-percent-form.vue?vue&type=template&id=3613ea75"
import script from "./survey-funding-percent-form.component.ts?vue&type=script&lang=ts&external"
export * from "./survey-funding-percent-form.component.ts?vue&type=script&lang=ts&external"
import style0 from "./survey-funding-percent-form.vue?vue&type=style&index=0&id=3613ea75&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports